export var IFrameioAuthenticationStatus;
(function (IFrameioAuthenticationStatus) {
    IFrameioAuthenticationStatus[IFrameioAuthenticationStatus["authLoggedOut"] = 0] = "authLoggedOut";
    IFrameioAuthenticationStatus[IFrameioAuthenticationStatus["authLoggedIn"] = 1] = "authLoggedIn";
    IFrameioAuthenticationStatus[IFrameioAuthenticationStatus["authExpired"] = 2] = "authExpired";
})(IFrameioAuthenticationStatus || (IFrameioAuthenticationStatus = {}));
